import type { ClaimCardTone } from '@/components/molecules'
import { PET_CLAIM_STATUS } from '@/shared/types/global.types'

// Submitted claims report the insurance core's status and the set is open:
// unknown ones still render, with the default tone and their raw value
const STATUS_TONE: Record<string, ClaimCardTone> = {
  [PET_CLAIM_STATUS.PARTIAL]: 'warning',
  [PET_CLAIM_STATUS.PENDING_MEDICAL_HISTORY]: 'warning',
  [PET_CLAIM_STATUS.APPROVED]: 'success',
  [PET_CLAIM_STATUS.PAID]: 'success',
  [PET_CLAIM_STATUS.DENIED]: 'error',
  [PET_CLAIM_STATUS.CLOSED]: 'neutral',
  [PET_CLAIM_STATUS.DELETED]: 'neutral',
}

export function getClaimStatusTone(status?: string): ClaimCardTone {
  return (status && STATUS_TONE[status]) || 'info'
}

/** i18n key for a status; unknown statuses fall back to the raw value */
export function getClaimStatusKey(status?: string): string {
  return `claims.statuses.${status ?? ''}`
}

/** Only claims not yet submitted to the insurance core can be edited */
export function isClaimEditable(status?: string): boolean {
  return (
    status === PET_CLAIM_STATUS.PARTIAL || status === PET_CLAIM_STATUS.FILEABLE
  )
}
